import { 후기_리치서치_컨텐츠들, 후기_리치서치_컨텐츠_개수들 } from "./review";
import { buildParlorLocalBusinessSchema } from "./parlorLocalBusiness";
import { PARLOR_REGION_FAQ_DATA, toFaqPageMainEntity } from "./faqData";

export function buildParlorRegionItemListSchema(
  parlors: Array<any>,
  options: { regionText: string; itemUrlBuilder: (id: number) => string },
) {
  if (!parlors || parlors.length === 0) return null;

  return {
    "@type": "ItemList",
    name: `${options.regionText} 장례식장 추천`,
    numberOfItems: parlors.length,
    itemListElement: parlors.map((p, i) => {
      const localBusiness = buildParlorLocalBusinessSchema(
        p,
        options.itemUrlBuilder(p.id),
      );
      const { "@context": _ctx, ...rest } = localBusiness;
      return {
        "@type": "ListItem",
        position: i + 1,
        item: rest,
      };
    }),
  };
}

// FAQ 데이터는 faqData.ts에서 단일 소스 관리 (UI 컴포넌트 ParlorRegionFAQ와 공유)

export function buildParlorRegionPageSchema(
  parlors: Array<any>,
  options: {
    regionText: string;
    itemUrlBuilder: (id: number) => string;
    ratingValue?: string;
  },
) {
  const graph: any[] = [];

  const itemList = buildParlorRegionItemListSchema(parlors, {
    regionText: options.regionText,
    itemUrlBuilder: options.itemUrlBuilder,
  });
  if (itemList) graph.push(itemList);

  graph.push({
    "@type": "Product",
    name: `${options.regionText} 장례식장 안내`,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: options.ratingValue ?? "4.97",
      bestRating: "5",
      ratingCount: 후기_리치서치_컨텐츠_개수들.전체,
      reviewCount: 후기_리치서치_컨텐츠_개수들.전체,
    },
    review: 후기_리치서치_컨텐츠들.전체.map((reviewBody, index) => ({
      "@type": "Review",
      reviewBody,
      author: {
        "@type": "Person",
        name: `상주${index}`,
      },
    })),
  });

  graph.push({
    "@type": "FAQPage",
    mainEntity: toFaqPageMainEntity(PARLOR_REGION_FAQ_DATA),
  });

  return {
    "@context": "https://schema.org",
    "@graph": graph,
  };
}
